import { DEFAULT_STATE } from '@/constants'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
    // Upload progress and results
    uploadProgress: 0,
    uploadedCreatives: [],
    currentUpload: null,

    // Form data
    uploadForm: {
      type: 'video', // 'video' or 'image'
      uploadMethod: 'UPLOAD_BY_FILE', // UPLOAD_BY_FILE, UPLOAD_BY_URL, UPLOAD_BY_FILE_ID, UPLOAD_BY_VIDEO_ID
      advertiserId: '7349406653265084417', // Default dev advertiser ID
      file: null,
      url: '',
      fileId: '',
      videoId: '',

      // Video specific options
      flawDetect: false,
      autoFixEnabled: false,
      autoBindEnabled: false,

      // Pre-review data
      adText: '',
      landingPageUrl: '',
      locationCodes: ['US'], // Default location code
      isEcommerce: false,
    },

    // Upload validation
    fileValidation: {
      isValid: true,
      errors: [],
    },

    // Creative management
    creativesList: [],
    creativesTotal: 0,
    creativesPage: 1,
    creativesPageSize: 10,
    creativesFilters: {
      search: '',
      type: '',
      status: '',
      preReviewStatus: '',
      dateRange: null,
    },
    creativesSort: {
      sortBy: 'uploadDate',
      sortDesc: true,
    },

    // Pre-review tasks
    preReviewTasks: [],
    preReviewPagination: {
      page: 1,
      size: 10,
      total: 0,
      total_pages: 0,
    },
  },
  getters,
  mutations,
  actions,
}
